import { Navigate, useParams } from 'react-router-dom';

import { url } from '../../../core/utils/link.ts';
import {
    MAILBOX_CATEGORY_DETAIL_PATH,
    MAILBOX_DETAIL_PATH,
    OVERVIEW_PATH as MAILBOXES_PATH,
} from '../../../products/mailboxes/constants.ts';

const SmartInboxRedirect = () => {
    const { integrationId, tab, categoryId } = useParams();

    const to = !integrationId
        ? MAILBOXES_PATH
        : categoryId
          ? url(MAILBOX_CATEGORY_DETAIL_PATH, { id: integrationId, categoryId })
          : url(MAILBOX_DETAIL_PATH, { id: integrationId, tab: tab === 'events' ? 'categories' : 'settings' });

    return <Navigate replace to={to} />;
};

export default SmartInboxRedirect;
